import { useOnMessagesUpdatedSubscription } from '@/__generated__/graphql';
import { getAuthRoleHeader } from '@/lib/apollo';
import { useEffect, useState } from 'react';
import { db } from '../../../lib/db';
import { useAuth } from '../../../stores/AuthContext';

export function useSyncData(conversationId: string | null) {
  const [syncing, setSyncing] = useState(false);
  const { user } = useAuth();

  const { data, loading, error } = useOnMessagesUpdatedSubscription({
    variables: {
      conversation_id: conversationId,
    },
    skip: !conversationId || !user,
    shouldResubscribe: true,
    context: getAuthRoleHeader('user'),
  });

  useEffect(() => {
    if (!user) {
      return;
    }

    if (data?.messages) {
      setSyncing(true);

      db.transaction('rw', db.messages, async () => {
        // await Dexie.waitFor(sleep(1000));

        // console.log('data', data.messages);

        const existingIds = await db.messages
          .where('conversation_id')
          .equals(conversationId!)
          .primaryKeys();
        const currentIds = new Set(data.messages.map((msg) => msg.id));

        const idsToDelete = Array.from(existingIds).filter(
          (id) => !currentIds.has(id as string),
        );

        await db.messages.bulkPut(
          data.messages.map((msg) => ({
            id: msg.id,
            conversation_id: msg.conversation_id,
            parent_id: msg.parent_id,
            role: msg.role as 'user' | 'assistant',
            content: msg.content,
            params: msg.params,
            created_at: new Date(msg.created_at),
            updated_at: new Date(msg.updated_at),
          })),
        );

        if (idsToDelete.length > 0) {
          await db.messages.bulkDelete(idsToDelete);
        }
      })
        .catch((error) => {
          console.error('Error syncing messages:', error);
        })
        .finally(() => {
          setSyncing(false);
        });
    }
  }, [data, conversationId, user]);

  return { loading, error, syncing };
}
